import {teaserListEvent} from '@sinclair-digital/stl-common/src/analytics/util';

// :: opts -> Promise
export const addTeaserOpened = teaserListEvent(true, 'manualTeaserOpened');

// :: opts -> Promise
export const addTeaserSave = teaserListEvent(true, 'manualTeaserAdded');

// :: opts -> Promise
export const changeTeaserPlacement = teaserListEvent(true, 'teaserPlacementChanged');

// :: opts -> Promise
export const editTeaserPlacement = teaserListEvent(true, 'teaserPlacementEditOpened');

// :: opts -> Promise
export const resetTeaserPlacement = teaserListEvent(true, 'teaserPlacementReset');

// :: opts -> Promise
export const saveTeaserPlacement = teaserListEvent(true, 'teaserPlacementSaved');

// :: opts -> Promise
export const conflictedTeaserPlacement = teaserListEvent(true, 'teaserPlacementConflicted');
